import LogsPage from '../pages/Logs.vue';
import AuditsPage from '../pages/Audits.vue';
import LoginPage from '../pages/Login.vue';
import NotFoundPage from '../pages/NotFound.vue';

export default [
  {
    path: '/',
    name: 'LogsPage',
    component: LogsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/audits',
    name: 'AuditsPage',
    component: AuditsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '*',
    name: 'NotFoundPage',
    component: NotFoundPage,
    meta: {
      requiresAuth: false,
    },
  },
];
